import React, { Component } from "react";
import MuiDialog from "material-ui/Dialog";
import IconButton from "material-ui/IconButton";
import Close from "components/icons/close";
import { DATATEST } from "constants/integration";

const styles = {
    close: {
        position: "absolute",
        top: "4px",
        right: "4px",
        height: "32px",
        width: "32px",
        padding: "8px",
    },
    closeIcon: {
        height: "16px",
        width: "16px",
    },
    actions: {
        textAlign: "right",
        padding: "20px 24px",
    },
    title: {
        borderBottom: "0px",
        padding: "24px 0 20px",
        marginBottom: "0px",
        marginLeft: "24px",
        marginRight: "24px",
    },
};

// eslint-disable-next-line
/** @augments {Component<any, any>} */
class Dialog extends Component {
    static defaultProps = {
        showCloseButton: true,
        autoScrollBodyContent: true,
    };

    handleClose = (e) => {
        const { onRequestClose } = this.props;
        e.stopPropagation();
        if (onRequestClose) {
            onRequestClose(e);
        }
    };

    handleStop(e) {
        e.stopPropagation();
    }

    UNSAFE_componentWillMount() {
        if (this.props.open) {
            this.setBodyFixed(true);
        }
    }

    componentWillUnmount() {
        if (this.props.open) {
            this.setBodyFixed(false);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open) {
            this.setBodyFixed(nextProps.open);
        }
    }

    setBodyFixed(isFixed) {
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        // const iOS11 = /OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_1_1|OS 11_1_2|OS 11_2|OS 11_2_1/.test(ua);

        // ios 11 bug caret position
        if (iOS) {
            if (isFixed) {
                document.body.classList.add("isFixed");
            } else {
                document.body.classList.remove("isFixed");
            }
        }
    }

    render() {
        // eslint-disable-next-line
        const {
            children,
            kabob = null,
            titleStyle,
            showCloseButton,
            actionsContainerStyle,
            contentStyle,
            bodyStyle,
            fixIOS,
            closeButtonStyle,
            closeIconStyle,
            style = {},
            dataTest = {},
            autoScrollBodyContent,
            ...props
        } = this.props;

        return (
            <MuiDialog
                {...props}
                className={`siteDialog ${this.props.className ? this.props.className : ""}`}
                style={style}
                contentStyle={Object.assign({ width: "90%", transform: "translateZ(0)" }, contentStyle)}
                titleStyle={Object.assign({}, styles.title, titleStyle)}
                actionsContainerStyle={Object.assign({}, styles.actions, actionsContainerStyle)}
                bodyStyle={Object.assign({}, { padding: "0 24px 16px", maxWidth: "100vw" }, bodyStyle)}
                autoScrollBodyContent={autoScrollBodyContent}
                data-test={dataTest.container || DATATEST.DIALOG.CONTAINER}
            >
                {kabob}
                {showCloseButton && (
                    <IconButton
                        data-test={dataTest.closeButton || DATATEST.DIALOG.CLOSE}
                        style={Object.assign({}, styles.close, closeButtonStyle)}
                        iconStyle={Object.assign({}, styles.closeIcon, closeIconStyle)}
                        onClick={this.handleClose}
                    >
                        <Close />
                    </IconButton>
                )}
                {children}
            </MuiDialog>
        );
    }
}

export default Dialog;
